import { Model } from "../lib";

export default class ReturnsStats extends Model {
  urlRoot = "/check_ins/destination_stats";
}
